<template>
  <div id="landing-line"></div>
</template>

<script>
export default {
  name: 'LandingLine',
}
</script>

<style lang="scss">
  div#landing-line { width: 90%; height: 3px; margin: 0 auto; background: $grayLighter; }
</style>
